import useModifiers from 'hooks/useModifiers';
import { t } from 'i18next';
import { StatusEnum } from 'models/general';
import StatusIcon, { StatusIconModifier } from './statusIcon';
import Tooltip, { TooltipAlignEnum, TooltipCursorEnum, TooltipModifier } from './tooltip';

export enum PlatformCardModifier {
  OLD = 'old',
  INTEGRATION = 'integration',
  OVERVIEW = 'overview',
  SMALL_HEIGHT = 'smallHeight',
}

export interface PlatformCardProps {
  icon?: React.ReactElement;
  logo_uri?: string;
  name: string;
  display_name: string;
  beta: boolean;
  warningCount?: number;
  modifiers?: PlatformCardModifier[];
}

function PlatformCard(props: PlatformCardProps) {
  const mods = useModifiers(props.modifiers);

  return (
    <div className={`ct_platformCard ${mods}`}>
      <div className="ct_platformCard-logo">
        {!!props.logo_uri && (
        <img src={props.logo_uri} alt={props.name} className={`${(props.logo_uri && props.logo_uri.endsWith('svg')) ? "ct_platformCard-svg" : "ct_platformCard-img" }`} />
        )}
        {!!props.icon && (
          props.icon
        )}
        <div className="ct_platformCard-name">
          <span className="ct_platformCard-nameText">
            {props.display_name}
          </span>
          {!!props.warningCount && (
            <div className="ct_platformCard-warningCount">
              <Tooltip
                title={props.warningCount > 1 ?
                  `${props.warningCount} ` + t('API Errors', { ns: 'validation' })
                  : `${props.warningCount} ` + t('API Error', { ns: 'validation' })
                } 
                modifiers={[]}
                align={TooltipAlignEnum.LEFT}
                cursor={TooltipCursorEnum.HELP}
              >
                <StatusIcon 
                  type={StatusEnum.WARNING}
                  modifiers={[StatusIconModifier.VALIDATION]} />
              </Tooltip>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

PlatformCard.defaultProps = { ...{} };

export default PlatformCard;
